import { css } from 'styled-components'

export default css`
  overflow: hidden;
  text-overflow: ellipsis;

  .unregistered-label {
    margin-left: 8px;
  }
`
